import React from 'react';


export default class QuestionLink extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<a href="#" className="question-link"><h2>发生化工爆炸事故时应如何自救?</h2></a>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/content/questionLink.js
 **/